import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VazeciProcenatZarade } from './vazeci-procenat-zarade';

@Component({
  selector: 'yt-vazeci-procenat-zarade-modal-update',
  templateUrl: './vazeci-procenat-zarade-modal-update.component.html'
})
export class VazeciProcenatZaradeModalUpdateComponent extends BaseModalUpdateComponent<VazeciProcenatZarade> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VazeciProcenatZarade>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
 

  ngOnInit() {
  }

}
